// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   ENTERPRISE MILESTONES & ROADMAP DESIGN SYSTEM
   Theme: Precision Clean SaaS (Linear / Stripe / Vercel style)
   ========================================================================== */

/* ── Hero / Overview Header ────────────────────────────────────────────── */
.milestones-hero-bar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.milestones-hero-left {
    flex: 1 1;
    min-width: 280px;
}

.milestones-badge-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: #eef2ff;
    color: #4f46e5;
    border: 1px solid #c7d2fe;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.milestones-hero-title {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 24px;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 6px 0;
    letter-spacing: -0.5px;
}

.milestones-hero-subtitle {
    font-size: 13px;
    color: #64748b;
    margin: 0 0 12px 0;
    max-width: 620px;
    line-height: 1.5;
}

.milestones-meta-chips {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.ms-meta-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 600;
    color: #475569;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.ms-meta-chip i {
    font-size: 12px;
    color: #6366f1;
}

.ms-chip-live {
    background: #ecfdf5;
    border-color: #a7f3d0;
    color: #065f46;
}

/* ── Hero Actions ──────────────────────────────────────────────────────── */
.milestones-hero-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.btn-ms-action {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #ffffff;
    color: #334155;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.btn-ms-action:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    color: #0f172a;
    transform: translateY(-1px);
}

/* ── Executive KPI Cards Grid ──────────────────────────────────────────── */
.ms-kpi-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
}

.ms-kpi-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 18px 20px;
    display: flex;
    flex-direction: column;
    position: relative;
    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);
    transition: all 0.25s ease;
}

.ms-kpi-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px -4px rgba(15, 23, 42, 0.08);
    border-color: #cbd5e1;
}

.ms-kpi-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.ms-kpi-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #64748b;
}

.ms-kpi-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}

.ms-icon-purple  { background: #f5f3ff; color: #7c3aed; }
.ms-icon-emerald { background: #ecfdf5; color: #10b981; }
.ms-icon-amber   { background: #fffbeb; color: #f59e0b; }
.ms-icon-sky     { background: #f0f9ff; color: #0284c7; }

.ms-kpi-main {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 8px;
}

.ms-kpi-val {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 24px;
    font-weight: 800;
    color: #0f172a;
    line-height: 1.1;
}

.ms-kpi-tag {
    font-size: 11px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 6px;
}

.tag-purple  { background: #f5f3ff; color: #5b21b6; }
.tag-emerald { background: #ecfdf5; color: #065f46; }
.tag-amber   { background: #fffbeb; color: #92400e; }
.tag-sky     { background: #f0f9ff; color: #075985; }

.ms-kpi-progress {
    width: 100%;
    height: 6px;
    background: #f1f5f9;
    border-radius: 9999px;
    overflow: hidden;
    margin-bottom: 8px;
}

.ms-kpi-progress-bar {
    height: 100%;
    border-radius: 9999px;
    transition: width 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.bg-bar-purple  { background: #8b5cf6; }
.bg-bar-emerald { background: #10b981; }
.bg-bar-amber   { background: #f59e0b; }
.bg-bar-sky     { background: #0ea5e9; }

.ms-kpi-sub {
    font-size: 11.5px;
    color: #64748b;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── Milestones Directory Card ─────────────────────────────────────────── */
.ms-main-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);
    margin-bottom: 30px;
}

.ms-toolbar {
    padding: 18px 22px;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
}

.ms-toolbar-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.ms-toolbar-title {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
}

.ms-count-badge {
    background: #eef2ff;
    color: #4f46e5;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 9999px;
}

.ms-toolbar-controls {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

/* Filter Tabs */
.ms-filter-tabs {
    display: flex;
    background: #f1f5f9;
    padding: 3px;
    border-radius: 8px;
    gap: 2px;
}

.ms-filter-btn {
    background: transparent;
    border: none;
    padding: 5px 10px;
    border-radius: 6px;
    font-size: 11.5px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    align-items: center;
    gap: 5px;
}

.ms-filter-btn:hover {
    color: #0f172a;
}

.ms-filter-btn.active {
    background: #ffffff;
    color: #4f46e5;
    font-weight: 700;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.ms-filter-count {
    font-size: 10px;
    padding: 1px 5px;
    border-radius: 9999px;
    background: #e2e8f0;
    color: #475569;
}

.ms-filter-btn.active .ms-filter-count {
    background: #eef2ff;
    color: #4f46e5;
}

/* Search Box */
.ms-search-box {
    position: relative;
    width: 220px;
}

.ms-search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #94a3b8;
    pointer-events: none;
}

.ms-search-input {
    width: 100%;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    padding-left: 30px;
    padding-right: 28px;
    font-size: 12.5px;
    background: #f8fafc;
    color: #0f172a;
    transition: all 0.2s ease;
}

.ms-search-input:focus {
    outline: none;
    background: #ffffff;
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.ms-search-clear {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 12px;
    color: #94a3b8;
    cursor: pointer;
    padding: 0;
}

/* ── Modern Table Styles ───────────────────────────────────────────────── */
.table-ms-custom {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    margin: 0;
}

.table-ms-custom thead {
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
}

.table-ms-custom th {
    padding: 13px 18px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #64748b;
    border: none;
    white-space: nowrap;
}

.table-ms-custom td {
    padding: 14px 18px;
    vertical-align: middle;
    border-bottom: 1px solid #f1f5f9;
    color: #334155;
}

.table-ms-custom tbody tr {
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.table-ms-custom tbody tr:hover {
    background-color: #f8fafc;
}

.table-ms-custom tbody tr:last-child td {
    border-bottom: none;
}

.ms-col-idx {
    font-weight: 700;
    color: #94a3b8;
    width: 44px;
}

.ms-title-cell {
    display: flex;
    align-items: center;
    gap: 10px;
}

.ms-icon-avatar {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #eef2ff;
    color: #4f46e5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
}

.ms-title-text {
    font-weight: 600;
    color: #0f172a;
    font-size: 13.5px;
    transition: color 0.15s;
}

.table-ms-custom tbody tr:hover .ms-title-text {
    color: #4f46e5;
}

.ms-date-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #475569;
    font-size: 12.5px;
    font-weight: 500;
    white-space: nowrap;
}

.ms-date-pill i {
    color: #94a3b8;
    font-size: 12px;
}

/* Days Pill */
.ms-days-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 9px;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
}

.days-overdue {
    background: #fef2f2;
    color: #b91c1c;
    border: 1px solid #fecaca;
}

.days-warning {
    background: #fffbeb;
    color: #b45309;
    border: 1px solid #fde68a;
}

.days-normal {
    background: #f0fdf4;
    color: #15803d;
    border: 1px solid #bbf7d0;
}

/* Priority Pill */
.ms-prio-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    text-transform: capitalize;
    white-space: nowrap;
}

.prio-high {
    background: #fef2f2;
    color: #b91c1c;
    border: 1px solid #fee2e2;
}

.prio-medium {
    background: #fffbeb;
    color: #b45309;
    border: 1px solid #fef3c7;
}

.prio-low {
    background: #f0fdf4;
    color: #15803d;
    border: 1px solid #dcfce7;
}

/* Status Badges */
.ms-status-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 11.5px;
    font-weight: 700;
    white-space: nowrap;
}

.status-completed {
    background: #ecfdf5;
    color: #065f46;
    border: 1px solid #a7f3d0;
}

.status-inprogress {
    background: #eef2ff;
    color: #3730a3;
    border: 1px solid #c7d2fe;
}

.status-notstarted {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #e2e8f0;
}

.btn-view-tasks {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 11.5px;
    font-weight: 600;
    color: #4f46e5;
    background: #eef2ff;
    border: 1px solid #c7d2fe;
    transition: all 0.15s ease;
}

.btn-view-tasks:hover {
    background: #4f46e5;
    color: #ffffff;
}

/* ── Empty & Loading States ────────────────────────────────────────────── */
.ms-empty-state {
    padding: 60px 20px;
    text-align: center;
    color: #64748b;
}

.ms-empty-icon-wrap {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    background: #f1f5f9;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    margin: 0 auto 16px auto;
}

.ms-empty-title {
    font-size: 16px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.ms-empty-desc {
    font-size: 13px;
    color: #94a3b8;
    max-width: 420px;
    margin: 0 auto 20px auto;
    line-height: 1.5;
}

.ms-loading-wrap {
    padding: 60px 20px;
    text-align: center;
    color: #64748b;
}

.ms-spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #e2e8f0;
    border-top-color: #4f46e5;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin: 0 auto 12px auto;
}
/* ── AMC Specific Styles ─────────────────────────────────────────────── */
.ms-type-pill-group {
    display: inline-flex;
    align-items: center;
    background: #f1f5f9;
    padding: 3px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
}

.ms-type-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 8px;
    border: none;
    background: transparent;
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s ease;
}

.ms-type-btn:hover {
    color: #0f172a;
}

.ms-type-btn.active {
    background: #4f46e5;
    color: #ffffff;
    box-shadow: 0 1px 3px rgba(79, 70, 229, 0.3);
}

.amc-icon-avatar {
    background: #eef2ff !important;
    color: #4f46e5 !important;
}

.ms-hours-pill {
    display: inline-flex;
    align-items: center;
    padding: 3px 9px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    font-family: inherit;
}

.hours-allocated {
    background: #f0f9ff;
    color: #0284c7;
    border: 1px solid #bae6fd;
}

.hours-worked {
    background: #fffbeb;
    color: #d97706;
    border: 1px solid #fde68a;
}

.hours-remaining {
    background: #ecfdf5;
    color: #059669;
    border: 1px solid #a7f3d0;
}

.hours-negative {
    background: #fef2f2;
    color: #dc2626;
    border: 1px solid #fecaca;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Milestones.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E,6EAA6E;AAC7E;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iDAAiD;IACjD,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,mDAAmD;IACnD,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;;AAExD;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;;AAEpD;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,oDAAoD;AACxD;;AAEA,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;;AAEvC;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,6EAA6E;AAC7E;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,iDAAiD;IACjD,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA,6EAA6E;AAC7E;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,cAAc;AACd;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,wBAAwB;AAC5B;AACA,2EAA2E;AAC3E;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B","sourcesContent":["/* ==========================================================================\n   ENTERPRISE MILESTONES & ROADMAP DESIGN SYSTEM\n   Theme: Precision Clean SaaS (Linear / Stripe / Vercel style)\n   ========================================================================== */\n\n/* ── Hero / Overview Header ────────────────────────────────────────────── */\n.milestones-hero-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 20px;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n}\n\n.milestones-hero-left {\n    flex: 1;\n    min-width: 280px;\n}\n\n.milestones-badge-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: #eef2ff;\n    color: #4f46e5;\n    border: 1px solid #c7d2fe;\n    border-radius: 9999px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 8px;\n}\n\n.milestones-hero-title {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 24px;\n    font-weight: 800;\n    color: #0f172a;\n    margin: 0 0 6px 0;\n    letter-spacing: -0.5px;\n}\n\n.milestones-hero-subtitle {\n    font-size: 13px;\n    color: #64748b;\n    margin: 0 0 12px 0;\n    max-width: 620px;\n    line-height: 1.5;\n}\n\n.milestones-meta-chips {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.ms-meta-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 11px;\n    font-weight: 600;\n    color: #475569;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n.ms-meta-chip i {\n    font-size: 12px;\n    color: #6366f1;\n}\n\n.ms-chip-live {\n    background: #ecfdf5;\n    border-color: #a7f3d0;\n    color: #065f46;\n}\n\n/* ── Hero Actions ──────────────────────────────────────────────────────── */\n.milestones-hero-actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.btn-ms-action {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n    background: #ffffff;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.btn-ms-action:hover {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    color: #0f172a;\n    transform: translateY(-1px);\n}\n\n/* ── Executive KPI Cards Grid ──────────────────────────────────────────── */\n.ms-kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.ms-kpi-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n    padding: 18px 20px;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);\n    transition: all 0.25s ease;\n}\n\n.ms-kpi-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 24px -4px rgba(15, 23, 42, 0.08);\n    border-color: #cbd5e1;\n}\n\n.ms-kpi-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.ms-kpi-label {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    color: #64748b;\n}\n\n.ms-kpi-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n}\n\n.ms-icon-purple  { background: #f5f3ff; color: #7c3aed; }\n.ms-icon-emerald { background: #ecfdf5; color: #10b981; }\n.ms-icon-amber   { background: #fffbeb; color: #f59e0b; }\n.ms-icon-sky     { background: #f0f9ff; color: #0284c7; }\n\n.ms-kpi-main {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.ms-kpi-val {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 24px;\n    font-weight: 800;\n    color: #0f172a;\n    line-height: 1.1;\n}\n\n.ms-kpi-tag {\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 7px;\n    border-radius: 6px;\n}\n\n.tag-purple  { background: #f5f3ff; color: #5b21b6; }\n.tag-emerald { background: #ecfdf5; color: #065f46; }\n.tag-amber   { background: #fffbeb; color: #92400e; }\n.tag-sky     { background: #f0f9ff; color: #075985; }\n\n.ms-kpi-progress {\n    width: 100%;\n    height: 6px;\n    background: #f1f5f9;\n    border-radius: 9999px;\n    overflow: hidden;\n    margin-bottom: 8px;\n}\n\n.ms-kpi-progress-bar {\n    height: 100%;\n    border-radius: 9999px;\n    transition: width 0.8s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.bg-bar-purple  { background: #8b5cf6; }\n.bg-bar-emerald { background: #10b981; }\n.bg-bar-amber   { background: #f59e0b; }\n.bg-bar-sky     { background: #0ea5e9; }\n\n.ms-kpi-sub {\n    font-size: 11.5px;\n    color: #64748b;\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* ── Milestones Directory Card ─────────────────────────────────────────── */\n.ms-main-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);\n    margin-bottom: 30px;\n}\n\n.ms-toolbar {\n    padding: 18px 22px;\n    border-bottom: 1px solid #f1f5f9;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 14px;\n}\n\n.ms-toolbar-left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.ms-toolbar-title {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 16px;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0;\n}\n\n.ms-count-badge {\n    background: #eef2ff;\n    color: #4f46e5;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 8px;\n    border-radius: 9999px;\n}\n\n.ms-toolbar-controls {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n/* Filter Tabs */\n.ms-filter-tabs {\n    display: flex;\n    background: #f1f5f9;\n    padding: 3px;\n    border-radius: 8px;\n    gap: 2px;\n}\n\n.ms-filter-btn {\n    background: transparent;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 6px;\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.ms-filter-btn:hover {\n    color: #0f172a;\n}\n\n.ms-filter-btn.active {\n    background: #ffffff;\n    color: #4f46e5;\n    font-weight: 700;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.ms-filter-count {\n    font-size: 10px;\n    padding: 1px 5px;\n    border-radius: 9999px;\n    background: #e2e8f0;\n    color: #475569;\n}\n\n.ms-filter-btn.active .ms-filter-count {\n    background: #eef2ff;\n    color: #4f46e5;\n}\n\n/* Search Box */\n.ms-search-box {\n    position: relative;\n    width: 220px;\n}\n\n.ms-search-icon {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 12px;\n    color: #94a3b8;\n    pointer-events: none;\n}\n\n.ms-search-input {\n    width: 100%;\n    height: 34px;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n    padding-left: 30px;\n    padding-right: 28px;\n    font-size: 12.5px;\n    background: #f8fafc;\n    color: #0f172a;\n    transition: all 0.2s ease;\n}\n\n.ms-search-input:focus {\n    outline: none;\n    background: #ffffff;\n    border-color: #6366f1;\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);\n}\n\n.ms-search-clear {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    font-size: 12px;\n    color: #94a3b8;\n    cursor: pointer;\n    padding: 0;\n}\n\n/* ── Modern Table Styles ───────────────────────────────────────────────── */\n.table-ms-custom {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n    margin: 0;\n}\n\n.table-ms-custom thead {\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.table-ms-custom th {\n    padding: 13px 18px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: #64748b;\n    border: none;\n    white-space: nowrap;\n}\n\n.table-ms-custom td {\n    padding: 14px 18px;\n    vertical-align: middle;\n    border-bottom: 1px solid #f1f5f9;\n    color: #334155;\n}\n\n.table-ms-custom tbody tr {\n    cursor: pointer;\n    transition: background-color 0.15s ease;\n}\n\n.table-ms-custom tbody tr:hover {\n    background-color: #f8fafc;\n}\n\n.table-ms-custom tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.ms-col-idx {\n    font-weight: 700;\n    color: #94a3b8;\n    width: 44px;\n}\n\n.ms-title-cell {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.ms-icon-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    background: #eef2ff;\n    color: #4f46e5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    flex-shrink: 0;\n}\n\n.ms-title-text {\n    font-weight: 600;\n    color: #0f172a;\n    font-size: 13.5px;\n    transition: color 0.15s;\n}\n\n.table-ms-custom tbody tr:hover .ms-title-text {\n    color: #4f46e5;\n}\n\n.ms-date-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: #475569;\n    font-size: 12.5px;\n    font-weight: 500;\n    white-space: nowrap;\n}\n\n.ms-date-pill i {\n    color: #94a3b8;\n    font-size: 12px;\n}\n\n/* Days Pill */\n.ms-days-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 3px 9px;\n    border-radius: 9999px;\n    font-size: 11px;\n    font-weight: 700;\n    white-space: nowrap;\n}\n\n.days-overdue {\n    background: #fef2f2;\n    color: #b91c1c;\n    border: 1px solid #fecaca;\n}\n\n.days-warning {\n    background: #fffbeb;\n    color: #b45309;\n    border: 1px solid #fde68a;\n}\n\n.days-normal {\n    background: #f0fdf4;\n    color: #15803d;\n    border: 1px solid #bbf7d0;\n}\n\n/* Priority Pill */\n.ms-prio-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 3px 8px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: capitalize;\n    white-space: nowrap;\n}\n\n.prio-high {\n    background: #fef2f2;\n    color: #b91c1c;\n    border: 1px solid #fee2e2;\n}\n\n.prio-medium {\n    background: #fffbeb;\n    color: #b45309;\n    border: 1px solid #fef3c7;\n}\n\n.prio-low {\n    background: #f0fdf4;\n    color: #15803d;\n    border: 1px solid #dcfce7;\n}\n\n/* Status Badges */\n.ms-status-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 10px;\n    border-radius: 9999px;\n    font-size: 11.5px;\n    font-weight: 700;\n    white-space: nowrap;\n}\n\n.status-completed {\n    background: #ecfdf5;\n    color: #065f46;\n    border: 1px solid #a7f3d0;\n}\n\n.status-inprogress {\n    background: #eef2ff;\n    color: #3730a3;\n    border: 1px solid #c7d2fe;\n}\n\n.status-notstarted {\n    background: #f1f5f9;\n    color: #475569;\n    border: 1px solid #e2e8f0;\n}\n\n.btn-view-tasks {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 4px 10px;\n    border-radius: 6px;\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #4f46e5;\n    background: #eef2ff;\n    border: 1px solid #c7d2fe;\n    transition: all 0.15s ease;\n}\n\n.btn-view-tasks:hover {\n    background: #4f46e5;\n    color: #ffffff;\n}\n\n/* ── Empty & Loading States ────────────────────────────────────────────── */\n.ms-empty-state {\n    padding: 60px 20px;\n    text-align: center;\n    color: #64748b;\n}\n\n.ms-empty-icon-wrap {\n    width: 64px;\n    height: 64px;\n    border-radius: 16px;\n    background: #f1f5f9;\n    color: #94a3b8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 28px;\n    margin: 0 auto 16px auto;\n}\n\n.ms-empty-title {\n    font-size: 16px;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 6px;\n}\n\n.ms-empty-desc {\n    font-size: 13px;\n    color: #94a3b8;\n    max-width: 420px;\n    margin: 0 auto 20px auto;\n    line-height: 1.5;\n}\n\n.ms-loading-wrap {\n    padding: 60px 20px;\n    text-align: center;\n    color: #64748b;\n}\n\n.ms-spinner {\n    width: 36px;\n    height: 36px;\n    border: 3px solid #e2e8f0;\n    border-top-color: #4f46e5;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    margin: 0 auto 12px auto;\n}\n/* ── AMC Specific Styles ─────────────────────────────────────────────── */\n.ms-type-pill-group {\n    display: inline-flex;\n    align-items: center;\n    background: #f1f5f9;\n    padding: 3px;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n}\n\n.ms-type-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 14px;\n    border-radius: 8px;\n    border: none;\n    background: transparent;\n    font-size: 12px;\n    font-weight: 600;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.ms-type-btn:hover {\n    color: #0f172a;\n}\n\n.ms-type-btn.active {\n    background: #4f46e5;\n    color: #ffffff;\n    box-shadow: 0 1px 3px rgba(79, 70, 229, 0.3);\n}\n\n.amc-icon-avatar {\n    background: #eef2ff !important;\n    color: #4f46e5 !important;\n}\n\n.ms-hours-pill {\n    display: inline-flex;\n    align-items: center;\n    padding: 3px 9px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    font-family: inherit;\n}\n\n.hours-allocated {\n    background: #f0f9ff;\n    color: #0284c7;\n    border: 1px solid #bae6fd;\n}\n\n.hours-worked {\n    background: #fffbeb;\n    color: #d97706;\n    border: 1px solid #fde68a;\n}\n\n.hours-remaining {\n    background: #ecfdf5;\n    color: #059669;\n    border: 1px solid #a7f3d0;\n}\n\n.hours-negative {\n    background: #fef2f2;\n    color: #dc2626;\n    border: 1px solid #fecaca;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
